import React, { useMemo, useEffect } from 'react';
import { Spinner } from '../../../../common';
import EventForm from './EventForm.jsx';
import { AppBarCMS } from '../../../../basic';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import {
  useSaveCalendarEventMutation,
  useGetCalendarEventsQuery,
  useGetCalendarEventQuery,
} from '../../../../../redux/services/events.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient';
import dayjs from 'dayjs';
import { useGetNewsEditQuery } from '../../../../../redux/services/news';
import { useGetArticlesQuery } from '../../../../../redux/services/articles.jsx';
import { useToastMessages } from '../../../../../hooks/useToastMessages';

const EventsEdit = ({ mode }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const backUrl = location.state?.backUrl || routes.cmsCalendar;

  const isCreate = mode === 'create';
  const isEdit = mode === 'edit';

  const { data: calendarDetail, isLoading } = useGetCalendarEventQuery(id, {
    skip: !isEdit,
  });

  useEffect(() => {
    document.title = isEdit
      ? t('Úprava udalosti') + ' - FRI CMS'
      : t('Pridanie udalosti') + ' - FRI CMS';
  }, []); // Runs on mount

  const { saveSuccess: showSaveSuccess } = useToastMessages();

  const { data: newsCollection, isLoading: newsLoading } =
    useGetNewsEditQuery();

  const { data: articlesCollection, isLoading: articleLoading } =
    useGetArticlesQuery();

  const [saveCalendarEvent, { isSuccess: isSaveSuccess }] =
    useSaveCalendarEventMutation();

  const { refetch } = useGetCalendarEventsQuery();

  useEffect(() => {
    if (isSaveSuccess) {
      showSaveSuccess();
      navigate(backUrl);
      refetch();
    }
  }, [backUrl, isSaveSuccess, navigate, refetch, showSaveSuccess]);

  const pageTitle = isCreate ? t('Pridanie udalosti') : t('Úprava udalosti');

  const initialValues = useMemo(() => {
    return {
      ...calendarDetail,
      from: calendarDetail?.from ? dayjs(calendarDetail?.from) : dayjs(),
      to: calendarDetail?.to ? dayjs(calendarDetail?.to) : null,
    };
  }, [calendarDetail]);

  return (isEdit && isLoading) || newsLoading || articleLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={pageTitle}
        backUrl={backUrl}
        backUrlTooltip={t('Kalendár')}
        permissionsBasic={'calendar'}
      />
      <div style={{ margin: '10px' }}>
        <EventForm
          initialValues={initialValues}
          onSubmit={(values) => {
            saveCalendarEvent({ body: values, id });
          }}
          newsCollection={newsCollection}
          articlesCollection={articlesCollection}
        />
      </div>
    </>
  );
};

export default EventsEdit;
